
import gamifying from 'assets/img/homepage/difference_gamifying.svg'
import identity from 'assets/img/homepage/difference_identity.svg'
import prizes from 'assets/img/homepage/difference_prizes.svg'
import players from 'assets/img/homepage/difference_players.svg'
import marketplace from 'assets/img/homepage/difference_marketplace.svg'
import content from 'assets/img/homepage/difference_content.svg'

const HomepageDifference = ({activateLogin}) => {

  const differenceList = [
    {
      icon: gamifying,
      title: `Gamifying the Game`,
      descr: `TwoTwentyK makes a game out of making predictions. Players use trading card game mechanics to collect the cards needed to craft the predictions they want to make.`
    },
    {
      icon: identity,
      title: `Identity Card System`,
      descr: `All predictions start with an identity, a card you craft to match the birthdate and category of a famous person. Whether your prediction resolves true or false, the Identity card is always returned to you. Over time an Identity gains stats which maybe be used in the future to apply multipliers or bonuses that impact gameplay.`
    },
    {
      icon: prizes,
      title: `Real Cash Prizes`,
      descr: `Winning isn’t just about glory. Prize cards are distributed randomly in card packs. Their potential value is determined randomly as well. If your prediction resolves true, the prize card becomes redeemable for cash. If it resolves false, all you lose is the prize card itself.`
    },
    {
      icon: players,
      title: `Players Choice`,
      descr: `TwoTwentyK gives players the opportunity to make predictions about almost anything. We have events like football, golf and elections of course. How about awards shows? Reality TV? World events? Movie box office results? If it has a binary outcome a prediction can be made.`
    },
    {
      icon: marketplace,
      title: `In-Game Marketplace`,
      descr: `Our platform includes a peer-to-peer marketplace where you can buy and sell cards and card packs. Whether you’re building your collection or selling extra cards, the marketplace offers endless strategy opportunities.`
    },
    {
      icon: content,
      title: `Endless Content`,
      descr: `With the ability to create new collections at the push of a button, TwoTwentyK is able to provide a constant stream of new prediction opportunities to keep the game fresh and exciting.`
    },
  ]

  return (
    <section className="homepage-difference" id='difference'>
      <h2 className='homepage__second-title'>What’s Different About TwoTwentyK?</h2>
      <p className='homepage__description'>
        We combine the fun and excitement of buying and collecting trading cards with the thrill of making predictions,
        giving fans a whole new way to enjoy the events they love.
      </p>
      <ul className='homepage-difference__list'>
        {
          differenceList.map((item, index) => (
            <li className="homepage-difference__list-item" key={index}>
              <img src={item.icon} loading='lazy' alt="" />
              <b>{item.title}</b>
              <p>{item.descr}</p>
            </li>
          ))
        }
      </ul>
      <button className='homepage__play-now' onClick={activateLogin}>Play now</button>
    </section>
  )
}

export default HomepageDifference
